import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* refreshSmartGroup({ payload: { id, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.smartgroup.refresh, id });

    onSuccess && onSuccess(data.result);
    yield put(actions.refreshSmartGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.refreshSmartGroupFailed,
      handledErrors,
      endpoint: api.modifiers.smartgroup.refresh.url
    });
  }
}

export const refreshSmartGroupSaga = takeEvery(types.REFRESH_SMART_GROUP_REQUEST, refreshSmartGroup);